import { PropsWithChildren } from 'react';

import { DiagonalLogoMark } from '@/components/DiagonalLogo';
import { getWorkspaceSystemString } from '@/lib/workspaceValues';
import { DefaultWorkspaceSystemField } from '@/types/enums';

import { FlashMessages } from './FlashMessages';

export function GuestLayout({
  children,
  workspace
}: PropsWithChildren<{
  workspace?: Diagonal.Workspaces.Data.WorkspaceData;
}>) {
  const lightLogoUrl = workspace?.login_logo_light_url;
  const darkLogoUrl = workspace?.login_logo_dark_url;
  const website = getWorkspaceSystemString(workspace, DefaultWorkspaceSystemField.Website);

  return (
    <div className="flex h-screen flex-col items-center overflow-y-auto bg-background p-4 text-foreground">
      <div className="my-auto w-full space-y-6">
        <div className="flex justify-center">
          <a href={website ?? 'https://godiagonal.com'} className="mb-16">
            {lightLogoUrl || darkLogoUrl ? (
              <>
                {lightLogoUrl ? (
                  <img
                    src={lightLogoUrl}
                    alt={`${workspace?.name} Logo`}
                    className="dark:hidden"
                    style={{ width: '200px', height: 'auto' }}
                  />
                ) : null}
                {darkLogoUrl ? (
                  <img
                    src={darkLogoUrl}
                    alt={`${workspace?.name} Logo`}
                    className={lightLogoUrl ? 'hidden dark:block' : undefined}
                    style={{ width: '200px', height: 'auto' }}
                  />
                ) : null}
              </>
            ) : (
              <DiagonalLogoMark className="h-8 w-auto" />
            )}
          </a>
        </div>

        {children}
      </div>
      <FlashMessages />
    </div>
  );
}
